import { http } from '@/shared/api'
import type { ApiSingleResponse } from '@/shared/api'
import type { ReadOptions } from '@/shared/lib'
import { API } from '@/apps/adok/shared/api'

import type { SubscriptionStatus } from '../model/types'

/**
 * Hand-written rather than `createEntityApi`: nothing is listed, and what addresses a
 * subscription is the token out of a letter's footer rather than an id or a session.
 */

export const checkSubscription = (token: string, options?: ReadOptions) =>
  http.get<ApiSingleResponse<SubscriptionStatus>>(API.subscription, {
    params: { token },
    signal: options?.signal
  })

export const unsubscribe = (token: string) =>
  http.delete<ApiSingleResponse<SubscriptionStatus>>(API.subscription, {
    params: { token }
  })
